import { CheckoutFlowType, GuestCheckoutData } from './submitCheckoutV2.types';

export const submitCheckoutV2 = (checkoutFlowType: CheckoutFlowType, guestCheckoutData?: GuestCheckoutData) => {
    if (!window.fLoginFormsUtils) {
        return false;
    }

    return window.fLoginFormsUtils.submitCheckout(checkoutFlowType, guestCheckoutData);
};
